import React, {Component} from 'react';
import { getMyFoodList, deleteMyFoodItem } from '../../../store/actions/myFoodActions';
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import MyFoodTable from "./myFoodTable";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import { get } from "lodash";

class MyFood extends Component {
    state = {
		foodToBeDeleted: null,
    };
    
    componentDidMount() {
        this.props.getMyFoodList("limit=20");
    }

    showDeleteDialog = (food_id) => {
        this.setState({foodToBeDeleted: food_id});
    }

    deleteFoodItem = (yes) => {
        const food_id = this.state.foodToBeDeleted
        const successHandler = (event) => {
            this.props.getMyFoodList("limit=20");
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Food has been removed successfully!", "", 5000);
            }
        }
        if (yes && food_id) {
            this.props.deleteMyFoodItem(food_id, successHandler)
        }
        this.setState({foodToBeDeleted: null})
    }

    render () {
        const {getMyFoodList, foodList, history} = this.props
        const {foodToBeDeleted} = this.state
        return (
            <section className="page page-food-database">
				<div className="container">
					<h3>My Food Items</h3>
                    {foodList.results && foodList.results.length ? (
                        <MyFoodTable getData={getMyFoodList} myFoodList={foodList} history={history} deleteItem={this.showDeleteDialog}/>
                    ) : (
                        <div className="alert alert-info text-center p-3 mt-4">No personal food items found. Try adding one now!</div>
                    )}
                    <ConfirmDelete item={foodToBeDeleted} message={<div>Are you sure you want to delete?</div>} onEvent={this.deleteFoodItem} />
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    const { MyFood } = state;
    return {
        foodList: get(MyFood, "myFoodList", {}),
    }
}

const mapDispatchToProps = {
    getMyFoodList,
    deleteMyFoodItem
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyFood);